import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { setPushNotificationToken } from 'redux/services/NotificationService';

export const registerPushNotifications = async () => {
  if (Capacitor.getPlatform() === 'web') return;

  try {
    const permResult = await PushNotifications.requestPermissions();
    if (permResult.receive !== 'granted') {
      console.warn('Notification permission not granted');
      return;
    }

    await PushNotifications.register();

    PushNotifications.addListener('registration', (token) => {
      const payload = {
        deviceType: Capacitor.getPlatform(),
        deviceToken: token.value,
      };
      // console.log('✅ Push token:', token.value);
      setPushNotificationToken(payload);
    });

    PushNotifications.addListener('registrationError', (error) => {
      console.error('Push registration error:', error);
    });
  } catch (err) {
    console.error('Push registration failed:', err);
  }
};
